<div>
    <mat-progress-spinner
            [diameter]="24"
            class="background-gauge"
            [color]="'primary'"
            [mode]="'determinate'"
            [value]="49"
            strokeWidth="12">
    </mat-progress-spinner>
    <mat-progress-spinner
            [diameter]="24"
            class="front-gauge"
            [color]="'accent'"
            [mode]="'determinate'"
            [value]="gaugeValue"
            strokeWidth="12">
    </mat-progress-spinner>
    <div class="text-value">{{value}}</div>
</div>
